import { render, staticRenderFns } from "./BuyFromJCIList.vue?vue&type=template&id=53af66de"
import script from "./BuyFromJCIList.vue?vue&type=script&lang=js"
export * from "./BuyFromJCIList.vue?vue&type=script&lang=js"
import style0 from "./BuyFromJCIList.vue?vue&type=style&index=0&id=53af66de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports